export default __webpack_public_path__ + "static/media/icon-check-circle.b7aa96c2.svg";